import { replacer } from './session-storage-engine';

export const SESSION_STATE_KEY = 'state';

/**
 * Which call site wrote a sessionStorage snapshot. 'context-switch' is the
 * trusted, same-tab fast path (finalizeContextSwitchReload, right after this
 * tab's own jumpContext resolved a fresh org). 'unload-fallback' is a
 * best-effort snapshot from any tab close for any reason — restore must not
 * trust its org-derived fields as current.
 */
export type PersistKind = 'context-switch' | 'unload-fallback';

/** Shape written to sessionStorage before a context-switch reload. */
export function buildPersistedSessionState(
  state: CMx.ApplicationState
): CMx.ApplicationState {
  const {
    cases: { criteriaFilter, sortablePageable, items, roles },
    ...rest
  } = state;

  return {
    cases: {
      criteriaFilter,
      sortablePageable,
      items,
      roles,
      refreshList: true
    },
    ...rest
  };
}

/** Synchronously persist Redux state for reload bootstrap (do not rely on beforeunload). */
export function persistSessionState(state: CMx.ApplicationState, kind: PersistKind): void {
  try {
    const serializedState = JSON.stringify(
      { ...buildPersistedSessionState(state), __persistMeta: { kind } },
      replacer
    );
    window.sessionStorage.setItem(SESSION_STATE_KEY, serializedState);
  } catch (err) {
    console.error('persistSessionState failed', err);
  }
}
